import React, { useState, useEffect } from 'react';
import api from '../services/api';
import Button from './Button';

const CategoryManager = ({ shopId }) => {
  const [categories, setCategories] = useState([]);
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    theme: '',
    imageUrl: '',
    color: '#3b82f6',
  });
  const [editingCategory, setEditingCategory] = useState(null);

  useEffect(() => {
    const fetchCategories = async () => {
      if (!shopId) return;
      try {
        const res = await api.get(`/shops/${shopId}/categories`);
        setCategories(res.data);
      } catch (err) {
        console.error(err);
      }
    };
    fetchCategories();
  }, [shopId]);

  const { name, description, theme, imageUrl, color } = formData;

  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const resetForm = () => {
    setFormData({ name: '', description: '', theme: '', imageUrl: '', color: '#3b82f6' });
    setEditingCategory(null);
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!shopId) {
      console.error("Shop ID is not available.");
      return;
    }

    try {
      if (editingCategory) {
        // Update existing category
        const res = await api.put(`/categories/${editingCategory._id}`, formData);
        setCategories(categories.map(cat => cat._id === editingCategory._id ? res.data : cat));
      } else {
        // Create new category
        const res = await api.post(`/shops/${shopId}/categories`, formData);
        setCategories([...categories, res.data]);
      }
      resetForm();
    } catch (err) {
      console.error(err);
    }
  };

  const startEdit = (category) => {
    setEditingCategory(category);
    setFormData({
      name: category.name,
      description: category.description,
      theme: category.theme,
      imageUrl: category.imageUrl,
      color: category.color,
    });
  };

  const deleteCategory = async (id) => {
    try {
      await api.delete(`/categories/${id}`);
      setCategories(categories.filter((category) => category._id !== id));
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div>
      <h2 className="text-2xl font-bold mb-4">{editingCategory ? 'Edytuj Kategorię' : 'Dodaj Nową Kategorię'}</h2>
      <form onSubmit={onSubmit} className="mb-4 bg-gray-800 p-6 rounded-lg">
        <input
          type="text"
          name="name"
          value={name}
          onChange={onChange}
          placeholder="Nazwa kategorii"
          required
          className="input mb-2"
        />
        <input
          type="text"
          name="description"
          value={description}
          onChange={onChange}
          placeholder="Opis kategorii"
          required
          className="input mb-2"
        />
        <input
          type="text"
          name="theme"
          value={theme}
          onChange={onChange}
          placeholder="Temat"
          required
          className="input mb-2"
        />
        <input
          type="text"
          name="imageUrl"
          value={imageUrl}
          onChange={onChange}
          placeholder="URL obrazka"
          required
          className="input mb-2"
        />
        <input
          type="color"
          name="color"
          value={color}
          onChange={onChange}
          className="input mb-2"
        />
        <div className="flex items-center">
          <Button type="submit">{editingCategory ? 'Zapisz Zmiany' : 'Dodaj Kategorię'}</Button>
          {editingCategory && (
            <Button type="button" onClick={resetForm} variant="secondary" className="ml-4">
              Anuluj
            </Button>
          )}
        </div>
      </form>
      <div className="space-y-4">
        {categories.map((category) => (
          <div key={category._id} className="bg-gray-800 p-4 rounded-lg flex justify-between items-center">
            <div className="flex items-center">
              <div className="w-12 h-12 rounded-md mr-4" style={{ backgroundColor: category.color }}>
                {category.imageUrl && <img src={category.imageUrl} alt={category.name} className="w-full h-full object-cover rounded-md"/>}
              </div>
              <div>
                <p className="font-bold">{category.name}</p>
                <p className="text-sm text-gray-400">{category.description}</p>
              </div>
            </div>
            <div className="flex items-center">
              <Button onClick={() => startEdit(category)} variant="secondary" className="mr-2">
                Edytuj
              </Button>
              <Button onClick={() => deleteCategory(category._id)} variant="danger">
                Usuń
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CategoryManager;